export default "__VITE_ASSET__okycLGZw__"